import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { GraphQLService } from './graph-ql.service';
import { map } from 'rxjs/operators';
import { ShopifyError } from '../models';
import { mailingAddress } from './addresses.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersService extends GraphQLService {
  private STORAGE_KEY = 'CUSTOMER_TOKEN';

  constructor() {
    super();
  }

  GetOrders(token: string, after: string = '', take = 10, language?: string) {
    const args: any = { first: take };
    if (after) {
      args['after'] = after;
    }

    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('customer', { args: { customerAccessToken: token } }, (customer: any) => {
        customer.add('id');
        customer.addConnection('orders', { args }, (order: any) => {
          order.add('id');
          order.add('orderNumber');
          // order.add('quantity');
          order.add('processedAt');
          // order.add('title');
          order.add('fulfillmentStatus');
          order.add('financialStatus');
          order.add('canceledAt');
          order.add('cancelReason');
          // order.add('totalPrice');
          order.add('totalPriceV2', (p: any) => {
            p.add('amount');
            p.add('currencyCode');
          });
          order.add('subtotalPriceV2', (p: any) => {
            p.add('amount');
            p.add('currencyCode');
          });
          order.add('totalTaxV2', (p: any) => {
            p.add('amount');
            p.add('currencyCode');
          });
          order.add('totalShippingPriceV2', (p: any) => {
            p.add('amount');
            p.add('currencyCode');
          });
          order.add('successfulFulfillments', { args: { first: 20 } }, (p: any) => {
            p.add('trackingCompany');
            p.add('trackingInfo', { args: { first: 20 } }, (a: any) => {
              a.add('number');
              a.add('url');
            });
          });
          // order.add('currentSubtotalPrice', (p: any) => {
          //   p.add('amount');
          //   p.add('currencyCode');
          // });
          // order.add('currentTotalPrice', (p: any) => {
          //   p.add('amount');
          //   p.add('currencyCode');
          // });
          // order.add('currentTotalTax', (p: any) => {
          //   p.add('amount');
          //   p.add('currencyCode');
          // });
          order.add('shippingAddress', (o: any) => {
            mailingAddress(o, this.client);
          });
          order.addConnection('lineItems', { args: { first: 250 } }, (line: any) => {
            line.add('currentQuantity');
            line.add('quantity');
            line.add('title');
            line.add('discountedTotalPrice', (p: any) => {
              p.add('amount');
              p.add('currencyCode');
            });
            line.add('originalTotalPrice', (p: any) => {
              p.add('amount');
              p.add('currencyCode');
            });
            line.add('variant', (variant: any) => {
              variant.add('id');
              variant.add('product', (p: any) => {
                p.add('handle');
                p.add('id');
              });
              variant.add('title');
              // variant.add('price');
              variant.add('availableForSale');
              variant.add('quantityAvailable');
              variant.add('currentlyNotInStock');
              variant.add('sku');
              variant.add('barcode');
              variant.add('selectedOptions', (o: any) => {
                o.add('name');
                o.add('value');
              });
              variant.add('unitPrice', (o: any) => {
                o.add('currencyCode');
                o.add('amount');
              });
              variant.add('priceV2', (a: any) => {
                a.add('currencyCode');
                a.add('amount');
              });
              // variant.add('price', (a: any) => {
              //   a.add('currencyCode');
              //   a.add('amount');
              // });
              variant.add('metafields', { args: { identifiers: { namespace: 'website', key: 'color_code' } } }, (metafields: any) => {
                metafields.add('key');
                metafields.add('value');
              });
              variant.add('image', (image: any) => {
                image.add('src');
                image.add('id');
                image.add('altText');
                image.add('url', { args: { transform: { crop: this.client.enum('CENTER'), maxWidth: 600 } } });
              });
            });
          });
        });
      });
    });
    return from(this.client.send(query)).pipe(
      map((a: any) => {
        const errors = a['errors'] || [];
        if (errors.length) {
          throw errors as ShopifyError[];
        }
        return a['data'].customer.orders;
      })
    ) as Observable<any>;
  }
}
